<!-- Footer Start -->
<div class="bg-black w-100">
    <div class="container">
        <div class="row mt-5">
            <div class="col-lg-4 col-md-6">
                <a href="index.html">
                    <h1 class="text-status-primary mt-0">PRIMEDESK OFFICE SOLUTIONS</h1>
                </a>
                <h3 class="text-status-warning">Daily Essential, Delivered with Ease</h3>
                <p class="mt-4 text-light">At Primedesk, we are dedicated to supporting modern workplaces with essential
                    supplies that keep operations running
                    smoothly. <br />
                    From premium stationery and office consumables to housekeeping and cleaning materials, we deliver
                    only trusted,
                    high-quality products. <br />
                    Our commitment to reliability, consistency, and timely service ensures your office stays efficient,
                    organized, and always well-equipped.</p>
            </div>
            <div class="col-lg-3 col-md-6">
                <a href="#">
                    <h3 class="text-status-warning">Short Link</h3>
                </a>
                <div class="d-flex flex-column ">
                    <a class="mb-2 text-white short-link cursor-pointer" (click)="goToPage('about')">
                        <nb-icon class="text-status-warning" icon="chevron-right-outline"></nb-icon>About
                    </a>
                    <a class="mb-2 text-white short-link cursor-pointer" (click)="goToPage('product')">
                        <nb-icon class="text-status-warning" icon="chevron-right-outline"></nb-icon>Product
                    </a>
                    <a class="mb-2 text-white short-link cursor-pointer" (click)="goToPage('contact')">
                        <nb-icon class="text-status-warning" icon="chevron-right-outline"></nb-icon>Contact
                    </a>
                </div>
            </div>
            <div class="ml-auto col-lg-3 col-md-6 col-sm-12">
                <a href="contact.html">
                    <h3 class="text-status-warning"> Contact</h3>
                </a>
                <div class="text-white mt-4 d-flex flex-column contact-link">
                    <a href="#" class="pb-3 text-light border-bottom-status-white short-link d-flex">
                        <i class="fas fa-map-marker-alt mr-2 text-status-warning"></i>Ahmedabad, Gujarat
                        320007</a>
                    <a href="tel:+91 79906 02736" class="py-3 text-light border-bottom-status-white short-link d-flex">
                        <nb-icon icon="phone-outline" class="mr-2 text-status-warning"> </nb-icon>+91 79906 02736</a>
                    <a href="mailto:contact.primedesk@gmail.com"
                        class="py-3 text-light border-bottom short-link border-bottom-status-white  d-flex">
                        <nb-icon icon="message-square-outline"
                            class="mr-2 text-status-warning"></nb-icon>contact.primedesk@gmail.com</a>
                </div>
                <div class="d-flex justify-content-center mt-2">
                    <button nbButton status="warning" class="ml-2" shape="round"><nb-icon
                            icon="google"></nb-icon></button>
                    <button nbButton status="warning" class="ml-2" shape="round"><nb-icon
                            icon="facebook"></nb-icon></button>
                    <a class="text-white rounded-circle ml-2 d-flex justify-content-center align-items-center"
                        target="_blank" href="https://tinyurl.com/mu7p6tp4"><i class="fab fa-instagram"></i></a>
                    <button nbButton status="warning" class="ml-2" shape="round"><nb-icon
                            icon="linkedin"></nb-icon></button>

                </div>
                <!-- <div class="d-flex justify-content-center mt-2 pb-4">
                    <div>
                        <a class="text-status-warning jd-im m-1" target="_blank"
                            href="https://tinyurl.com/mu7p6tp4">Justdial
                        </a>
                    </div>
                    <div class="text-status-warning ">
                        &
                    </div>
                    <div>
                        <a class="text-status-warning jd-im m-1" target="_blank"
                            href="https://tinyurl.com/delta-im">indiamart
                        </a>
                    </div>
                </div> -->
            </div>
        </div>

        <hr class="text-light mt-5 mb-4">
        <div class="row">
            <div class="col-md-6 text-center text-md-start">
                <span class="text-light"><a href="#" class="text-third"><i
                            class="fas fa-copyright text-third me-2"></i>Primedesk</a>, All right
                    reserved.</span>
            </div>

        </div>
    </div>
</div>
<!-- Footer End -->